import { css } from "@emotion/react";

export const container = css`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
`;

export const sectionWrapper = css`
  margin: 48px 0;
`;

export const sectionTitle = css`
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
`;